import React, { useState, useRef } from 'react';
import { Upload, CheckCircle, AlertCircle, Loader, FileText } from 'lucide-react';
import { upload } from '../api';

export default function Carica() {
  const [file, setFile] = useState(null);
  const [carico, setCarico] = useState(false);
  const [risultato, setRisultato] = useState(null);
  const [errore, setErrore] = useState(null);
  const [drag, setDrag] = useState(false);
  const inputRef = useRef();

  const formatiAccettati = ['.pdf', '.docx', '.doc', '.txt', '.eml', '.xml'];

  const gestisciFile = (f) => {
    setRisultato(null);
    setErrore(null);
    if (!f) return;
    const ext = '.' + f.name.split('.').pop().toLowerCase();
    if (!formatiAccettati.includes(ext)) {
      setErrore(`Formato non supportato. Accettati: ${formatiAccettati.join(', ')}`);
      return;
    }
    setFile(f);
  };

  const carica = async () => {
    if (!file) return;
    setCarico(true);
    setErrore(null);
    setRisultato(null);
    try {
      const r = await upload(file);
      setRisultato(r.data);
      setFile(null);
    } catch (err) {
      setErrore(err.response?.data?.detail || 'Errore durante il caricamento.');
    } finally {
      setCarico(false);
    }
  };

  return (
    <div className="pagina">
      <div
        className={`drop-zone ${drag ? 'drag-over' : ''} ${file ? 'ha-file' : ''}`}
        onDragOver={e => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={e => {
          e.preventDefault();
          setDrag(false);
          gestisciFile(e.dataTransfer.files[0]);
        }}
        onClick={() => inputRef.current?.click()}
      >
        <input
          ref={inputRef}
          type="file"
          accept={formatiAccettati.join(',')}
          style={{ display: 'none' }}
          onChange={e => gestisciFile(e.target.files[0])}
        />
        {file ? (
          <>
            <FileText size={48} className="drop-icon file-ok" />
            <p className="drop-titolo">{file.name}</p>
            <p className="drop-sub">{(file.size / 1024).toFixed(1)} KB</p>
          </>
        ) : (
          <>
            <Upload size={48} className="drop-icon" />
            <p className="drop-titolo">Trascina un documento qui</p>
            <p className="drop-sub">oppure clicca per selezionarlo</p>
            <p className="drop-formati">{formatiAccettati.join(' · ')}</p>
          </>
        )}
      </div>

      {file && !carico && (
        <button className="btn-carica" onClick={carica}>
          <Upload size={18} />
          Indicizza documento
        </button>
      )}

      {carico && (
        <div className="carico-box">
          <Loader size={32} className="spin" />
          <p>Indicizzazione in corso...</p>
          <p className="carico-sub">Il documento viene suddiviso in chunk e vettorizzato</p>
        </div>
      )}

      {risultato && (
        <div className="alert successo">
          <CheckCircle size={18} />
          <span>
            <strong>{risultato.file}</strong> — {risultato.stato}
          </span>
        </div>
      )}

      {errore && (
        <div className="alert errore">
          <AlertCircle size={18} />
          <span>{errore}</span>
        </div>
      )}
    </div>
  );
}
